import type { IntlShape } from "react-intl";
import { GetOddsTranslationsHelper } from "../../../../../../helpers/getOddsTranslationsHelper";
import { GetLineTranslationsHelper } from "../GetLineTranslationsHelper/GetLineTranslationsHelper";
import { GetPregameTranslationsHelper } from "../GetPregameTranslationsHelper/GetPregameTranslationsHelper";
import { GetSortingTranslationsHelper } from "../GetSortingTranslationsHelper/GetSortingTranslationsHelper";
export class LoadFilterOptionsHelper {
  static loadFilterOptions(intl: IntlShape) {
    // load filter options data from helpers
    GetLineTranslationsHelper.getLineTranslations(intl);
    GetSortingTranslationsHelper.getSortingTranslations(intl);
    GetOddsTranslationsHelper.getOddsTranslations(intl);
    GetPregameTranslationsHelper.getPregameTranslations(intl);
  }
}
